import { RemoteClientPromotionType } from "../../../../data/usecases/promotion-type/remote-client-promotion-type";
import { PromotionType } from "../../../../domain/models/promotion-type";
import { makeAxiosHttpClient } from "../../http/axios-http-client-factory";

export const makeRemoteClientPromotionType = (): PromotionType =>
  new RemoteClientPromotionType("/clientPromotionType", makeAxiosHttpClient());
